import { render, staticRenderFns } from "./UveitisHome.vue?vue&type=template&id=15c17828&scoped=true&"
import script from "./UveitisHome.vue?vue&type=script&lang=js&"
export * from "./UveitisHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c17828",
  null
  
)

export default component.exports